import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ContactService } from '../services/contact.service';
import {
  DemoRequest,
  ContactRequest,
  PricingRequest
} from '../services/models/contact.model';

@Component({
  selector: 'bhub-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrl: './landing-page.component.scss',
  standalone: false
})
export class LandingPageComponent {

  mouseX: number = 0;
  mouseY: number = 0;
  expandedFeature: string | null = null;
  activeSection: string | null = null;

  constructor(private router: Router, private contactService: ContactService) {}

  // Mouse tracking for interactive background
  onMouseMove(event: MouseEvent): void {
    this.mouseX = event.clientX;
    this.mouseY = event.clientY;
  }

  // Navigation methods
  toggleNavigation(): void {
    const navDemo = document.getElementById('navDemo');
    if (navDemo) {
      if (navDemo.className.indexOf('w3-show') === -1) {
        navDemo.className += ' w3-show';
      } else {
        navDemo.className = navDemo.className.replace(' w3-show', '');
      }
    }
  }

    // Scroll to section methods
  scrollToSection(sectionId: string): void {
    // Special handling for contact and demo sections
    if (sectionId === 'contact' || sectionId === 'demo') {
      this.showSection(sectionId);
      return;
    }

    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }

  scrollToTop(): void {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  // Login method
  login(): void {
    // Navigate to the post-login entry point, which triggers authentication via
    // MsalGuard. Once signed in, /loading looks up how many applications the
    // user belongs to and forwards to the dashboard or the picker.
    this.router.navigate(['/loading']);
  }

          // Form submission methods
  onDemoFormSubmit(form: HTMLFormElement): void {
    const formData = new FormData(form);

    const request: DemoRequest = {
      name: formData.get('Name') as string,
      company: formData.get('Company') as string,
      email: formData.get('Email') as string,
      phone: formData.get('Phone') as string,
      demoDate: formData.get('DemoDate') as string,
      message: formData.get('Message') as string
    };

    // Submit demo request using contact service
    this.contactService.submitDemoRequest(request)
      .subscribe({
        next: (response) => {
          alert('Thank you for your demo request! We will contact you soon.');
          form.reset();
        },
        error: (error) => {
          console.error('Demo request failed:', error);
          alert('Sorry, there was an error sending your request. Please try again or contact us directly.');
        }
      });
  }

    onContactFormSubmit(form: HTMLFormElement): void {
    const formData = new FormData(form);

    const request: ContactRequest = {
      name: formData.get('Name') as string,
      email: formData.get('Email') as string,
      subject: formData.get('Subject') as string,
      message: formData.get('Message') as string
    };

    // Submit contact request using contact service
    this.contactService.submitContactRequest(request)
      .subscribe({
        next: (response) => {
          alert('Thank you for your message! We will get back to you soon.');
          form.reset();
        },
        error: (error) => {
          console.error('Contact message failed:', error);
          alert('Sorry, there was an error sending your message. Please try again or contact us directly.');
        }
      });
  }

  // Pricing button click handlers
  onPricingButtonClick(plan: string): void {
    this.scrollToSection('contact');
  }

  // Social media link handlers
  onSocialMediaClick(platform: string): void {
    // Here you would typically open the social media profile
    // For now, just log the action
  }

  // Feature expansion methods
  toggleFeature(featureId: string): void {
    if (this.expandedFeature === featureId) {
      this.expandedFeature = null;
    } else {
      this.expandedFeature = featureId;
    }
  }

  // Pricing consultation request
  requestPricingConsultation(): void {
    // Show the pricing consultation section
    this.showSection('pricing');
  }

  // Section visibility methods
  showSection(sectionId: string): void {
    // If clicking the same section that's already active, close it
    if (this.activeSection === sectionId) {
      this.activeSection = null;
    } else {
      this.activeSection = sectionId;
      // Scroll to the action bar only when opening a section
      const actionBar = document.querySelector('.action-bar');
      if (actionBar) {
        actionBar.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }

    // Pricing form submission
  onPricingFormSubmit(form: HTMLFormElement): void {
    const formData = new FormData(form);

    const request: PricingRequest = {
      name: formData.get('Name') as string,
      email: formData.get('Email') as string,
      company: formData.get('Company') as string,
      phone: formData.get('Phone') as string,
      companySize: formData.get('CompanySize') as string,
      consultationDate: formData.get('ConsultationDate') as string,
      challenges: formData.get('Challenges') as string
    };

    // Submit pricing request using contact service
    this.contactService.submitPricingRequest(request)
      .subscribe({
        next: (response) => {
          alert('Thank you for your pricing consultation request! We will contact you soon to schedule your call.');
          form.reset();
          this.activeSection = null;
        },
        error: (error) => {
          console.error('Pricing consultation request failed:', error);
          alert('Sorry, there was an error sending your request. Please try again or contact us directly.');
        }
      });
  }

}
